import { Heading } from "./Heading"

export const SidebarHeader = Heading;
